import styled from 'particles/themes/styled'
import { theme } from 'theme'
import { menuClasses } from '@mui/material/Menu'
import RichContentMenu from 'particles/Menu/RichContentMenu'

export const StyledRichContentMenu = styled(RichContentMenu)`
    & .${menuClasses.paper} {
        & .${menuClasses.list} {
            flex-flow: column wrap;
            max-height: 512px;
            width: 924px;
        }
    }
`

export const RequirementContainer = styled.div`
    position: relative;
    .requirement-list {
        width: 964px;
        display: flex;
        position: absolute;
        bottom: 14px;
        flex-direction: column;
        padding: ${theme.newSpacing.xxs};
        gap: ${theme.newSpacing.l};
        flex-wrap: wrap;
        max-height: 450px;
        max-width: 964px;
        background-color: ${theme.newColors.neutral50};
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
        box-sizing: border-box;
        .requirement-row {
            display: flex;
            flex-direction: column;
            gap: ${theme.newSpacing.xxs};
        }
        .requirement-title {
            font-size: ${theme.newFontSizes.xs};
            font-weight: ${theme.fontWeight.bold};
            color: ${theme.newColors.neutral400};
        }
        @media screen and (max-width: 768px) {
            padding: ${theme.newSpacing.xxs};
            width: 316px;
            left: 0;
            flex-wrap: nowrap;
            overflow-y: scroll;
            overflow-x: hidden;
        }
    }
`
export const LocationRequirementContainer = styled.div`
    .drop-down-input-area {
        padding-top: 27.5px;
    }
    .drop-down-double-selector {
        display: flex;
        gap: ${theme.newSpacing.l};
        padding: ${theme.newSpacing.l} 0;
        box-sizing: border-box;
        position: relative;
        .remove-field-icon {
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
        }
        @media screen and (max-width: 768px) {
            flex-direction: column;
        }
    }
    .add-field-button {
        margin-top: ${theme.newSpacing.l};
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.xxs};
    }
    .dropdown-category-label {
        color: ${theme.newColors.neutral400};
    }
`
export const BlockedCampaignsContainer = styled.div`
    .divider {
        margin: ${theme.newSpacing.l} 0;
    }
    .campaign-list {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.xxxxs};
    }
    .block-campaign {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid ${theme.newColors.neutral200};
        border-radius: 4px;
        min-height: 38px;
        line-height: 38px;
        padding: 0 ${theme.newSpacing.s};
        height: fit-content;
        position: relative;
        .remove-field-icon {
            position: absolute;
            top: 6px;
            right: 0;
            cursor: pointer;
        }
    }
`
